// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require('admin-lte');
require("jquery");

import 'bootstrap';
import "@fortawesome/fontawesome-free/js/all";
require("trix")
require("@rails/actiontext")

// 各モジュールをインポート
import { handleSwiperTurbolinks } from '../modules/swiper_handler';
import { handleMenuTurbolinks } from '../modules/menu_handler';
import { handlePopupTurbolinks } from '../modules/popup_handler';
import { handleSwiperGalleryTurbolinks } from '../modules/swiper_gallery_handler';
import "../modules/stock_inquiry_cart";
import '../modules/select2_init';
import '../modules/category_select';
import '../modules/variant_maker_search_toggle';

// 各モジュールの Turbolinks ハンドラをセットアップ
handleSwiperTurbolinks();
handleMenuTurbolinks();
handlePopupTurbolinks();
handleSwiperGalleryTurbolinks();

// application.js のカスタムロジック部分の最後に記述

$(document).on('click', 'a[href="#category-group-content"]', function (e) {
  // リンク遷移とBootstrapの自動動作を確実に停止
  e.preventDefault();

  const $trigger = $(this);
  const $target = $('#category-group-content');
  const $icon = $trigger.find('.collapse-arrow');

  // Bootstrapのクラスを使って状態を判断
  if ($target.hasClass('show')) {
    // 状態: 開いている -> 閉じる

    // 1. UIの更新 (アイコン/アクティブクラス)
    $icon.removeClass('fa-angle-down').addClass('fa-angle-left');
    $trigger.addClass('collapsed').removeClass('active-footer-collapse').attr('aria-expanded', 'false');

    // 2. コンテンツの非表示 (jQueryのAPIでアニメーション化し、showクラスを削除)
    $target.slideUp(300, function () {
      $target.removeClass('show');
    });

  } else {
    // 状態: 閉じている -> 開く

    // 1. UIの更新
    $icon.removeClass('fa-angle-left').addClass('fa-angle-down');
    $trigger.removeClass('collapsed').addClass('active-footer-collapse').attr('aria-expanded', 'true');

    // 2. コンテンツの表示
    $target.addClass('show').hide(); // showクラスを付与し、slideDown前に非表示設定
    $target.slideDown(300); // jQueryのAPIでアニメーション表示
  }
});